/* eslint-disable */
// @generated by protobuf-ts 2.9.4 with parameter ts_nocheck,add_pb_suffix,keep_enum_prefix,eslint_disable
// @generated from protobuf file "adp/services/edge_auth/proto/auth_metadata_service.proto" (package "adp.services.edge_auth.proto", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AuthMetadata } from "./auth_metadata_service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CheckDomainAuthorizationResponse } from "./auth_metadata_service_pb";
import type { CheckDomainAuthorizationRequest } from "./auth_metadata_service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * Check the authorization for a particular domain.
 * NOTE: These rpcs are all publicly accessible!
 *
 * @generated from protobuf service adp.services.edge_auth.proto.AuthMetadata
 */
export interface IAuthMetadataClient {
    /**
     * CheckDomainAuthorization checks whether a particular domain might be able
     * to access the product. However, this should NOT be load bearing. This is solely
     * for the FE to be able to check ahead of time whether a particular request would fail
     * before trying to attempt SSO for an unauthorized domain.
     *
     * @generated from protobuf rpc: CheckDomainAuthorization(adp.services.edge_auth.proto.CheckDomainAuthorizationRequest) returns (adp.services.edge_auth.proto.CheckDomainAuthorizationResponse);
     */
    checkDomainAuthorization(input: CheckDomainAuthorizationRequest, options?: RpcOptions): UnaryCall<CheckDomainAuthorizationRequest, CheckDomainAuthorizationResponse>;
}
/**
 * Check the authorization for a particular domain.
 * NOTE: These rpcs are all publicly accessible!
 *
 * @generated from protobuf service adp.services.edge_auth.proto.AuthMetadata
 */
export class AuthMetadataClient implements IAuthMetadataClient, ServiceInfo {
    typeName = AuthMetadata.typeName;
    methods = AuthMetadata.methods;
    options = AuthMetadata.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * CheckDomainAuthorization checks whether a particular domain might be able
     * to access the product. However, this should NOT be load bearing. This is solely
     * for the FE to be able to check ahead of time whether a particular request would fail
     * before trying to attempt SSO for an unauthorized domain.
     *
     * @generated from protobuf rpc: CheckDomainAuthorization(adp.services.edge_auth.proto.CheckDomainAuthorizationRequest) returns (adp.services.edge_auth.proto.CheckDomainAuthorizationResponse);
     */
    checkDomainAuthorization(input: CheckDomainAuthorizationRequest, options?: RpcOptions): UnaryCall<CheckDomainAuthorizationRequest, CheckDomainAuthorizationResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckDomainAuthorizationRequest, CheckDomainAuthorizationResponse>("unary", this._transport, method, opt, input);
    }
}
